<template>
    <div class="agent-register">
        <div class="section-title">基本信息</div>
        <div class="form-panel">
            <div class="form-item full">
                <div class="form-label">申请人名称 <span>*</span></div>
                <van-field
                    v-model.trim="form.groupName"
                    placeholder="请输入"
                    maxlength="50"
                    clearable
                    border
                />
            </div>

            <div class="form-grid">
                <div class="form-item">
                    <div class="form-label">联系人 <span>*</span></div>
                    <van-field
                        v-model.trim="form.contactName"
                        placeholder="请输入"
                        maxlength="50"
                        clearable
                        border
                    />
                </div>
                <div class="form-item">
                    <div class="form-label">
                        登录账号 <span>*</span>
                        <van-popover
                            v-model:show="loginTipShow"
                            theme="dark"
                            trigger="click"
                            placement="top"
                        >
                            <div class="help-popover">
                                长度8-15位，可为纯数字或数字加英文字母
                            </div>
                            <template #reference>
                                <van-icon name="question" class="label-help" />
                            </template>
                        </van-popover>
                    </div>
                    <van-field
                        class="login-account"
                        v-model.trim="form.contactMobile"
                        label="c"
                        placeholder="请输入"
                        maxlength="15"
                        clearable
                        border
                    />
                </div>
            </div>

            <div class="form-grid">
                <div class="form-item clickable" @click="staffListShow = true">
                    <div class="form-label">负责员工 <span>*</span></div>
                    <div
                        class="display-value"
                        :class="{ placeholder: !form.principalName }"
                    >
                        {{ form.principalName || '请选择' }}
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        关联手机号 <span>*</span>
                        <van-popover
                            v-model:show="relationMobileTipShow"
                            theme="dark"
                            trigger="click"
                            placement="top"
                        >
                            <div class="help-popover">
                                用于验证码登录使用，多个账号可使用同一个关联手机号
                            </div>
                            <template #reference>
                                <van-icon name="question" class="label-help" />
                            </template>
                        </van-popover>
                    </div>
                    <van-field
                        v-model.trim="form.phoneNumber"
                        type="tel"
                        placeholder="请输入"
                        maxlength="11"
                        clearable
                        border
                    />
                </div>
            </div>

            <div class="form-grid">
                <div class="form-item clickable" @click="openAddressPicker">
                    <div class="form-label">省市区 <span>*</span></div>
                    <div
                        class="display-value"
                        :class="{ placeholder: !addressText }"
                    >
                        {{ addressText || '请选择' }}
                        <van-icon name="arrow" class="inline-arrow" />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">其他联系方式</div>
                    <van-field
                        v-model.trim="form.contactOtherMobile"
                        type="tel"
                        placeholder="请输入"
                        maxlength="50"
                        clearable
                        border
                    />
                </div>
            </div>

            <div class="form-item full">
                <div class="form-label">详细地址 <span>*</span></div>
                <van-field
                    v-model.trim="form.address"
                    placeholder="请输入"
                    maxlength="50"
                    clearable
                    border
                />
            </div>

            <div class="form-item clickable full" @click="openAreaPopup">
                <div class="form-label">代理区域 <span>*</span></div>
                <div
                    class="display-value"
                    :class="{ placeholder: !groupAreaText }"
                >
                    {{ groupAreaText || '请选择' }}
                    <van-icon name="arrow" class="inline-arrow" />
                </div>
                <div v-if="selectedGroupAreas.length" class="area-tags">
                    <van-tag
                        v-for="item in selectedGroupAreas"
                        :key="item.code"
                        closeable
                        plain
                        type="primary"
                        class="area-tag"
                        @close="removeGroupArea(item.code)"
                    >
                        {{ item.name }}
                    </van-tag>
                </div>
            </div>

            <div class="form-item full remark-item">
                <div class="form-label">备注</div>
                <van-field
                    v-model="form.remark"
                    rows="1"
                    autosize
                    type="textarea"
                    maxlength="200"
                    placeholder="请输入"
                    show-word-limit
                    border
                />
            </div>
        </div>

        <template v-if="showRealNameModule">
            <div class="section-title">实名认证</div>
            <div class="real-name-tip">
                根据国家实名制法规要求，请填写真实的证件信息
            </div>
            <div class="form-panel">
                <div
                    class="form-item full clickable"
                    @click="idTypeShow = true"
                >
                    <div class="form-label">
                        证件类型 <span v-if="forceRealNameRequired">*</span>
                    </div>
                    <div
                        class="display-value"
                        :class="{ placeholder: !idTypeText }"
                    >
                        {{ idTypeText || '请选择' }}
                        <van-icon name="arrow" class="inline-arrow" />
                    </div>
                </div>
                <div class="form-item full">
                    <div class="form-label">
                        真实姓名 <span v-if="forceRealNameRequired">*</span>
                    </div>
                    <van-field
                        v-model.trim="form.realName"
                        placeholder="请输入"
                        maxlength="50"
                        clearable
                        border
                    />
                </div>
                <div class="form-item full">
                    <div class="form-label">
                        证件编号 <span v-if="forceRealNameRequired">*</span>
                    </div>
                    <van-field
                        v-model.trim="form.idCard"
                        placeholder="请输入"
                        maxlength="50"
                        clearable
                        border
                    />
                </div>
            </div>
        </template>

        <div class="bottom-actions">
            <van-button
                block
                class="confirm-button"
                :loading="submitting"
                loading-text="提交中..."
                @click="save"
            >
                确认注册
            </van-button>
        </div>

        <van-dialog
            v-model="confirmDialogShow"
            title="提示"
            show-cancel-button
            confirm-button-text="确认"
            cancel-button-text="取消"
            :close-on-click-overlay="false"
            @confirm="submitRegister"
        >
            <div class="confirm-dialog-content">是否确认注册？</div>
        </van-dialog>

        <van-dialog
            v-model="successDialogShow"
            :show-confirm-button="false"
            :close-on-click-overlay="false"
            class="success-dialog"
        >
            <div class="success-dialog-content">
                注册成功，请打开（聚充充助手）微信小程序进行登录
            </div>
        </van-dialog>

        <van-popup v-model="addressPickerShow" position="bottom">
            <van-picker
                show-toolbar
                title="省市区"
                :columns="addressColumns"
                value-key="text"
                @confirm="confirmAddress"
                @cancel="addressPickerShow = false"
            />
        </van-popup>

        <van-popup v-model="areaPopupShow" position="bottom" class="area-popup">
            <div class="popup-header">
                <button type="button" @click="areaPopupShow = false">
                    取消
                </button>
                <strong>代理区域</strong>
                <button type="button" @click="confirmGroupArea">确定</button>
            </div>
            <div class="area-columns">
                <div class="area-column">
                    <div
                        v-for="item in oneList"
                        :key="item.code"
                        class="area-row"
                        :class="{
                            active: oneSelect && oneSelect.code === item.code,
                        }"
                        @click="changeAreaSelect(1, item)"
                    >
                        <van-checkbox
                            :value="isAreaChecked(item)"
                            @click.stop="toggleGroupArea(item, 1)"
                        />
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <div class="area-column middle">
                    <div
                        v-for="item in twoList"
                        :key="item.code"
                        class="area-row"
                        :class="{
                            active: twoSelect && twoSelect.code === item.code,
                        }"
                        @click="changeAreaSelect(2, item)"
                    >
                        <van-checkbox
                            :value="isAreaChecked(item)"
                            @click.stop="toggleGroupArea(item, 2)"
                        />
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <div class="area-column">
                    <div
                        v-for="item in threeList"
                        :key="item.code"
                        class="area-row"
                        @click="toggleGroupArea(item, 3)"
                    >
                        <van-checkbox :value="isAreaChecked(item)" />
                        <span>{{ item.name }}</span>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="staffListShow" position="bottom">
            <van-search
                v-model="staffSearchValue"
                placeholder="请输入检索内容"
                @input="handleStaffSearch"
            />
            <van-picker
                show-toolbar
                title="请选择负责员工"
                :columns="staffColumns"
                value-key="text"
                @confirm="confirmStaff"
                @cancel="staffListShow = false"
            />
        </van-popup>

        <van-popup v-model="idTypeShow" position="bottom">
            <van-picker
                show-toolbar
                title="证件类型"
                :columns="idTypeColumns"
                value-key="text"
                @confirm="confirmIdType"
                @cancel="idTypeShow = false"
            />
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant';
import {
    addAgent,
    getAddressTree,
    getBelongEmployees,
    getForceRealNameRequired,
    getForceRealNameSwitch,
    getIdTypeList,
} from '@/api/jcc';

const MOBILE_REG = /^1[3-9]\d{9}$/;
const LOGIN_ACCOUNT_REG = /^(?=.*\d)[A-Za-z0-9]{8,15}$/;

export default {
    name: 'JccAddAgent',
    data() {
        return {
            // 从 jcc-b 的 agent_edit 迁移过来的代理商注册主表单。
            form: {
                // 名片Id
                cardId: '',

                groupName: '',
                contactName: '',
                contactMobile: '',
                phoneNumber: '',
                contactOtherMobile: '',
                principal: '',
                principalName: '',
                provinceCode: '',
                provinceName: '',
                cityCode: '',
                cityName: '',
                districtCode: '',
                districtName: '',
                address: '',
                groupArea: [],
                sharedRevenue: '',
                linePercent: '',
                salePercent: '',
                remark: '',
                idType: '',
                realName: '',
                idCard: '',
            },
            // 分享/名片入口会把分成比例、员工等信息放在 query，提交时需要原样带回。
            shareQuery: {},
            // 省市区基础数据，同时服务“所在地”和“代理区域”两个选择器。
            addressTree: [],
            addressColumns: [],
            // code -> 区域节点的索引，用于代理区域选择时处理父子互斥。
            areaMap: {},
            addressPickerShow: false,
            areaPopupShow: false,
            // 代理区域三列选择数据：省、市、区。
            oneList: [],
            twoList: [],
            threeList: [],
            oneSelect: null,
            twoSelect: null,
            // 已选择的代理区域，使用对象是为了快速增删和去重。
            checkedAreaMap: {},
            staffListShow: false,
            staffList: [],
            staffSearchValue: '',
            staffTimer: null,
            // 实名认证配置由后端控制，沿用 jcc-b 的开关逻辑。
            forceRealName: false,
            forceRealNameRequired: false,
            idTypeShow: false,
            idTypeList: [],
            loginTipShow: false,
            relationMobileTipShow: false,
            confirmDialogShow: false,
            successDialogShow: false,
            submitting: false,
        };
    },
    computed: {
        // 所在地展示文案。
        addressText() {
            const { provinceName, cityName, districtName } = this.form;
            return provinceName
                ? [provinceName, cityName, districtName]
                      .filter(Boolean)
                      .join(' ')
                : '';
        },
        selectedGroupAreas() {
            return Object.values(this.checkedAreaMap);
        },
        // 代理区域已选摘要，避免区域过多时撑开单元格。
        groupAreaText() {
            const list = this.selectedGroupAreas;
            if (!list.length) return '';
            if (list.length <= 2)
                return list.map((item) => item.name).join('、');
            return `${list[0].name}、${list[1].name}等${list.length}个区域`;
        },
        // 后端员工字段和 Vant Picker 字段做一层兼容转换。
        staffColumns() {
            return this.staffList.map((item) => ({
                ...item,
                text: item.text || item.employeeName || item.label || item.name,
                value: item.value || item.employeeId || item.id,
            }));
        },
        // 后端证件类型字段和 Vant Picker 字段做一层兼容转换。
        idTypeColumns() {
            return this.idTypeList.map((item) => ({
                ...item,
                text: item.desc || item.name || item.text,
                value: item.code || item.value,
            }));
        },
        idTypeText() {
            const item = this.idTypeColumns.find(
                (item) => `${item.value}` === `${this.form.idType}`
            );
            return item ? item.text : '';
        },
        // 实名认证字段为非必填时，隐藏整个实名认证模块。
        showRealNameModule() {
            return this.forceRealName && this.forceRealNameRequired;
        },
    },
    created() {
        // 获取url的参数
        const params = {};
        new URLSearchParams(window.location.search).forEach(
            (v, k) => (params[k] = v)
        );
        console.log('params', params);
        this.form.cardId = params.cardId;
        // 进入页面先初始化 query、地址、员工、实名配置和证件类型。
        this.initFromQuery();
        this.getAddressTree();
        this.getStaffList();
        this.getRealNameConfig();
        this.getIdTypes();
    },
    methods: {
        // 名片/分享链接可预置分成比例、负责员工等字段。
        initFromQuery() {
            const query = { ...this.$route.query };
            this.shareQuery = query;
            this.form.sharedRevenue =
                query.sharedRevenue || query.curSharedPercent || '';
            this.form.linePercent = query.linePercent || '';
            this.form.salePercent = query.salePercent || '';
            this.form.principal = query.principal || query.employeeId || '';
            this.form.principalName = query.principalName || '';
            this.form.phoneNumber = query.phoneNumber || '';
            this.form.remark = query.remark || '';
        },
        // 兼容 axios 原始响应和已被拦截器解包的响应。
        responseBody(res) {
            return res && res.data !== undefined ? res.data : res;
        },
        responseData(res) {
            const body = this.responseBody(res);
            return body && body.data !== undefined ? body.data : body;
        },
        responseSuccess(res) {
            const body = this.responseBody(res);
            if (!body) return false;
            if (body.success === false) return false;
            if (
                body.code !== undefined &&
                !['000', 200, '200'].includes(body.code)
            )
                return false;
            return true;
        },
        responseMsg(res, fallback) {
            const body = this.responseBody(res);
            return (body && (body.msg || body.message)) || fallback;
        },
        // 拉取省市区树，jcc-b 原页面依赖缓存，这里在 H5 页面内直接请求。
        async getAddressTree() {
            try {
                const res = await getAddressTree({
                    association: this.form.cardId,
                });
                if (!this.responseSuccess(res)) return;
                const list = this.responseData(res) || [];
                this.addressTree = list;
                this.addressColumns = this.toPickerColumns(list);
                this.areaMap = this.createAreaMap(list);
                this.oneList = list;
            } catch (error) {
                console.error(error);
            }
        },
        // 把后端 cityAreaResDTOList 树转换成 Vant Picker 的 columns。
        toPickerColumns(list) {
            return (list || []).map((item) => {
                const column = {
                    text: item.name,
                    value: item.code,
                    raw: item,
                };
                if (item.cityAreaResDTOList && item.cityAreaResDTOList.length) {
                    column.children = this.toPickerColumns(
                        item.cityAreaResDTOList
                    );
                }
                return column;
            });
        },
        // 建立区域索引，代理区域选择时用于向上/向下取消互斥项。
        createAreaMap(list, map = {}) {
            (list || []).forEach((item) => {
                map[item.code] = item;
                this.createAreaMap(item.cityAreaResDTOList, map);
            });
            return map;
        },
        // 打开所在地选择器。
        openAddressPicker() {
            if (!this.addressColumns.length) {
                Toast('地址数据加载中，请稍后');
                this.getAddressTree();
                return;
            }
            this.addressPickerShow = true;
        },
        // 选择所在地后，拆成后端需要的省/市/区 code 和 name。
        confirmAddress(values, indexes = []) {
            const rawList = this.getAddressByIndexes(indexes, values);
            const province = rawList[0] || {};
            const city = rawList[1] || {};
            const district = rawList[2] || {};
            this.form.provinceCode = province.code || province.value || '';
            this.form.provinceName = province.name || province.text || '';
            this.form.cityCode = city.code || city.value || '';
            this.form.cityName = city.name || city.text || '';
            this.form.districtCode = district.code || district.value || '';
            this.form.districtName = district.name || district.text || '';
            this.addressPickerShow = false;
        },
        // Vant2 级联 Picker confirm 第一个参数是 text 数组，这里用 indexes 回到原始地址树取 code。
        getAddressByIndexes(indexes = [], values = []) {
            const result = [];
            let list = this.addressTree || [];
            for (let i = 0; i < indexes.length; i++) {
                const item = list[indexes[i]];
                if (!item) break;
                result.push(item);
                list = item.cityAreaResDTOList || [];
            }
            if (result.length) return result;

            // 兜底兼容非级联返回对象或文本的情况。
            const selected = Array.isArray(values) ? values : [values];
            let currentList = this.addressTree || [];
            return selected.map((item, index) => {
                if (item && typeof item === 'object') return item.raw || item;
                const area =
                    currentList.find((area) => area.name === item) || {};
                currentList = area.cityAreaResDTOList || [];
                return area;
            });
        },
        // 打开代理区域选择器，复刻 jcc-b 省/市/区三列勾选交互。
        openAreaPopup() {
            if (!this.addressTree.length) {
                Toast('地址数据加载中，请稍后');
                this.getAddressTree();
                return;
            }
            this.oneList = this.addressTree;
            if (!this.oneSelect && this.oneList.length) {
                this.changeAreaSelect(1, this.oneList[0]);
            }
            this.areaPopupShow = true;
        },
        // 点击省或市时联动下一列数据。
        changeAreaSelect(type, item) {
            if (type === 1) {
                this.oneSelect = item;
                this.twoSelect = null;
                this.twoList = item.cityAreaResDTOList || [];
                this.threeList = [];
                return;
            }
            if (type === 2) {
                this.twoSelect = item;
                this.threeList = item.cityAreaResDTOList || [];
            }
        },
        isAreaChecked(item) {
            return !!this.checkedAreaMap[item.code];
        },
        // 勾选代理区域，并保持省、市、区之间互斥：选下级会取消上级，选上级会取消下级。
        toggleGroupArea(item, level) {
            this.changeAreaSelect(level, item);
            const map = { ...this.checkedAreaMap };
            const checked = !!map[item.code];
            if (checked) {
                delete map[item.code];
            } else {
                map[item.code] = this.toGroupAreaItem(item);
                if (item.type !== 1) this.deleteUpper(map, item);
                if (item.type !== 3) this.deleteLower(map, item);
            }
            this.checkedAreaMap = map;
            this.form.groupArea = Object.values(map);
        },
        // 选中市/区时取消已选中的上级省/市。
        deleteUpper(map, item) {
            if (!item || item.type === 1) return;
            const parent = this.areaMap[item.parentCode];
            delete map[item.parentCode];
            if (parent) this.deleteUpper(map, parent);
        },
        // 选中省/市时取消已选中的下级市/区。
        deleteLower(map, item) {
            (item.cityAreaResDTOList || []).forEach((child) => {
                delete map[child.code];
                this.deleteLower(map, child);
            });
        },
        toGroupAreaItem(item) {
            return {
                parentCode: item.parentCode,
                code: item.code,
                name: item.name,
                type: item.type,
            };
        },
        // 从已选标签里移除代理区域。
        removeGroupArea(code) {
            const map = { ...this.checkedAreaMap };
            delete map[code];
            this.checkedAreaMap = map;
            this.form.groupArea = Object.values(map);
        },
        confirmGroupArea() {
            this.form.groupArea = this.selectedGroupAreas;
            this.areaPopupShow = false;
        },
        // 查询负责员工列表，保留 jcc-b 的 employeeName 搜索能力。
        async getStaffList(employeeName) {
            try {
                const res = await getBelongEmployees({
                    employeeName,
                    association: this.form.cardId,
                });
                if (!this.responseSuccess(res)) return;
                const data = this.responseData(res);
                const list = data && data.list ? data.list : data || [];
                this.staffList = list.map((item) => ({
                    ...item,
                    text: item.employeeName || item.text || item.label,
                    value: item.employeeId || item.value || item.id,
                }));
                if (this.form.principal && !this.form.principalName) {
                    const current = this.staffList.find(
                        (item) => `${item.value}` === `${this.form.principal}`
                    );
                    if (current) this.form.principalName = current.text;
                }
            } catch (error) {
                console.error(error);
            }
        },
        // 员工搜索防抖，减少输入时的接口请求。
        handleStaffSearch(value) {
            clearTimeout(this.staffTimer);
            this.staffTimer = setTimeout(() => {
                this.getStaffList(value);
            }, 500);
        },
        confirmStaff(item) {
            this.form.principal = item.value;
            this.form.principalName = item.text;
            this.staffListShow = false;
        },
        // 获取实名认证开关和实名字段是否必填。
        async getRealNameConfig() {
            try {
                const switchRes = await getForceRealNameSwitch({
                    association: this.form.cardId,
                });
                const requiredRes = await getForceRealNameRequired({
                    association: this.form.cardId,
                });
                this.forceRealName = this.responseData(switchRes) !== 0;
                this.forceRealNameRequired =
                    this.responseData(requiredRes) == 1;
            } catch (error) {
                console.error(error);
            }
        },
        // 获取证件类型枚举，接口返回什么就展示什么。
        async getIdTypes() {
            try {
                const res = await getIdTypeList({
                    association: this.form.cardId,
                });
                if (!this.responseSuccess(res)) return;
                const data = this.responseData(res) || [];
                this.idTypeList = Array.isArray(data)
                    ? data
                    : Object.keys(data).map((code) => ({
                          code,
                          desc: data[code],
                      }));
                const first = this.idTypeColumns[0];
                if (first && !this.form.idType) this.form.idType = first.value;
            } catch (error) {
                console.error(error);
            }
        },
        confirmIdType(item) {
            this.form.idType = item.value;
            this.idTypeShow = false;
        },
        // 只有实名认证模块展示时才做实名字段校验。
        validateRealName() {
            if (this.showRealNameModule) {
                if (!this.form.realName) {
                    Toast('请输入真实姓名');
                    return false;
                }
                if (!this.form.idCard) {
                    Toast('请输入证件编号');
                    return false;
                }
            }
            return true;
        },
        // 提交前的主表单校验，规则从 jcc-b agent_edit 页面迁移。
        validateForm() {
            if (!this.form.groupName) {
                Toast('请输入代理名称');
                return false;
            }
            if (!this.form.contactName) {
                Toast('请输入联系人');
                return false;
            }
            if (!this.form.contactMobile) {
                Toast('请输入登录账号');
                return false;
            }
            if (!LOGIN_ACCOUNT_REG.test(this.form.contactMobile)) {
                Toast('登录账号长度8-15位，可为纯数字或数字加英文字母');
                return false;
            }

            //   TODO 关联手机号校验
            if (
                !this.form.phoneNumber ||
                !MOBILE_REG.test(this.form.phoneNumber)
            ) {
                Toast('请输入正确的关联手机号');
                return false;
            }
            if (!this.form.principal) {
                Toast('请选择负责员工');
                return false;
            }
            if (!this.form.provinceCode) {
                Toast('请选择省市区');
                return false;
            }
            if (!this.form.address) {
                Toast('请输入详细地址');
                return false;
            }
            if (!this.form.groupArea.length) {
                Toast('请选择代理区域');
                return false;
            }
            return this.validateRealName();
        },
        // 组装注册接口参数：保留分享 query，同时覆盖为表单最新值。
        buildSubmitParam() {
            const query = { ...this.shareQuery };
            delete query.code;
            return {
                ...query,
                ...this.form,
                idType: this.form.idType,
                registerSource: query.registerSource || 'JCC',
                referKey: query.referKey || query.agentCode || query.referKey,
                contactMobile: 'c' + this.form.contactMobile
            };
        },
        // 提交新增代理商注册。
        save() {
            if (!this.validateForm() || this.submitting) return;
            this.confirmDialogShow = true;
        },
        async submitRegister() {
            if (this.submitting) return;
            this.submitting = true;
            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0,
            });
            try {
                const res = await addAgent(this.buildSubmitParam());
                Toast.clear();
                if (this.responseSuccess(res)) {
                    this.successDialogShow = true;
                    return;
                }
                Toast(this.responseMsg(res, '提交失败'));
            } catch (error) {
                Toast.clear();
                Toast(this.responseMsg(error, '提交失败'));
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.agent-register {
    min-height: 100vh;
    padding-bottom: 88px;
    background: #f7f7fb;
}

.section-title {
    padding: 8px 12px;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    background: #f2f1f7;
}

.form-panel {
    background: #fff;
}

.form-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.form-item {
    min-width: 0;
    min-height: 74px;
    padding: 12px 14px 8px;
    background: #fff;
    border-bottom: 1px solid #f1f1f1;
    box-sizing: border-box;

    &.full {
        width: 100%;
    }

    &.clickable {
        cursor: pointer;
    }

    ::v-deep .van-cell {
        min-height: 24px;
        padding: 0;
        line-height: 24px;
    }

    ::v-deep .van-field__control {
        color: #333;
        font-size: 15px;
        line-height: 24px;
    }

    ::v-deep .van-field__control::placeholder {
        color: #9b9b9b;
    }

    ::v-deep .van-field__word-limit {
        margin-top: 8px;
        color: #333;
        font-size: 12px;
    }
}

.form-label {
    display: flex;
    align-items: center;
    min-width: 0;
    margin-bottom: 6px;
    color: #666;
    font-size: 15px;
    line-height: 22px;

    span {
        margin-left: 3px;
        color: #ee0a24;
    }
}

.label-help {
    margin-left: 5px;
    color: #999;
    font-size: 13px;
}

.help-popover {
    width: 136px;
    padding: 5px 15px;
    color: #fff !important;
    font-size: 12px;
    line-height: 20px;
}

// ::v-deep .van-popover {
//   color: #333;
// }

// ::v-deep .van-popover__content,
// ::v-deep .van-popover__action {
//   color: #333 !important;
//   background: #d7d7d7 !important;
//   border-radius: 3px;
// }

// ::v-deep .van-popover__arrow {
//   color: #d7d7d7 !important;
//   background-color: #d7d7d7;
// }

.display-value {
    display: flex;
    align-items: center;
    min-height: 24px;
    color: #333;
    font-size: 15px;
    line-height: 24px;
    word-break: break-all;

    &.placeholder {
        color: #9b9b9b;
    }
}

.inline-arrow {
    flex: 0 0 auto;
    margin-left: 5px;
    color: #999;
    font-size: 16px;
}

.remark-item {
    min-height: 78px;
}

.area-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 0px 12px;
    background: #fff;
}

.area-tag {
    max-width: 100%;
}

.real-name-tip {
    padding: 8px 12px 10px;
    color: #111;
    font-size: 12px;
    line-height: 17px;
    background: #fff;
}

.bottom-actions {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20;
    padding: 12px 22px 18px;
    background: #fff;
}

.confirm-button {
    height: 52px;
    color: #fff;
    font-size: 17px;
    font-weight: 500;
    line-height: 52px;
    background: #5d6df6;
    border: 0;
    border-radius: 26px;
}

.confirm-dialog-content {
    padding: 22px 24px 10px;
    color: #333;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}

.success-dialog-content {
    padding: 36px 24px;
    color: #333;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid #f1f1f1;

    button {
        padding: 0;
        color: #1989fa;
        font-size: 14px;
        background: transparent;
        border: 0;
    }

    strong {
        color: #333;
        font-size: 16px;
    }
}

.area-popup {
    height: 70vh;
}

.area-columns {
    display: flex;
    height: calc(70vh - 48px);
}

.area-column {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
    background: #fff;

    &.middle {
        background: #f2f8ff;
    }
}

.area-row {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 8px 10px;
    color: #333;
    font-size: 13px;
    box-sizing: border-box;

    &.active {
        background: #e6f2ff;
    }

    span {
        flex: 1;
        min-width: 0;
        margin-left: 8px;
        word-break: break-all;
    }
}
.login-account{
    ::v-deep .van-field__label{
        width: 10px;
        margin-right: 5px;
    }
}
</style>
